import { Injectable } from '@angular/core';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { IPaging } from '../models/promoWebInterface';

export enum EProductCategory {
  TIRE = 'tire',
  LUBRICANT = 'lubricant',
  BRAKE = 'brake',
}

export enum ETireDecInc {
  INCREASE = 'inc',
  DECREASE = 'dec',
}

export enum ESearchBlockPath {
  SIZE = 'size',
  WIDTH = 'width',
  HEIGHT = 'height',
  TYPE = 'type',
  TYPES = 'types',
  HIGHLIGHTS = 'highlights',
  BRAND = 'brand',
  MODEL = 'model',
  TYPE_NT = 'type-nt',
  BRAND_NT = 'brand-nt',
  MODEL_NT = 'model-nt',
}

export interface IApiResponseAll {
  ok: number;
  msg: string;
  status: number;
  data: IAllData;
}

export interface IAllData {
  rows: (
    | IContentNameRow
    | IContentRow
    | IImageLinkRow
    | IBranchRow
    | IPromotionsRow
    | INewsRow
    | IVideoData
    | IBanner
    | IProductRow
    | IGalleryData
  )[];
  cur?: string;
  per?: string;
  result_total?: number;
  total_rows?: number;
}

export interface IProductRow {
  id: number;
  name: string;
  badge: string;
  price: number;
  short_description: string;
  product_model?: string;
  content: string;
  tire_width: number;
  tire_height: number;
  tire_size: number;
  attr_brand: string;
  attr_model: string;
  attr_type: string;
  attr_road: string;
  attr_position: string;
  attr_range: string;
  attr_extra_a: string;
  attr_extra_b: string;
  attr_extra_c: string;
  perf_a: number;
  perf_b: number;
  perf_c: number;
  perf_d: number;
  perf_e: number;
  perf_f: number;
  block_content_a_image: string;
  block_content_a_title: string;
  block_content_a_info: string;
  block_content_b_image: string;
  block_content_b_title: string;
  block_content_b_info: string;
  block_content_c_image: string;
  block_content_c_title: string;
  block_content_c_info: string;
  block_content_d_image: string;
  block_content_d_title: string;
  block_content_d_info: string;
  block_content_e_image: string;
  block_content_e_title: string;
  block_content_e_info: string;
  block_content_f_image: string;
  block_content_f_title: string;
  block_content_f_info: string;
  image_a: string;
  image_b: string;
  image_c: string;
  image_d: string;
  image_e: any;
  attr_product_a?: string;
  attr_product_b?: string;
  attr_product_c?: string;
  attr_product_d: any;
  attr_product_e: any;
  attr_product_f: any;
  attr_product_g: any;
  attr_product_h: any;
  attr_product_i: any;
  attr_product_j: any;
  brand_name: string;
  brand_image: string;
}
export interface IBanner {
  title: string;
  pc_image_url: string;
  mobile_image_url: string;
  link_url: string | null;
  position: number;
}
export interface IPromotionsRow {
  id: number;
  cover_image_url: string;
  excerpt: string;
  title: string;
  publish_time?: string;
  unpublish_time?: string;
}
export interface INewsRow {
  id: number;
  cover_image_url: string;
  excerpt: string;
  title: string;
  publish_time?: string;
  unpublish_time?: string;
}
export interface IContentNameRow {
  name: string;
}

interface IImageLinkRow {
  title: string;
  pc_image_url: string;
  mobile_image_url: string | null;
  link_url: string;
}

export interface IContentRow {
  id: string | number;
  cover_image_url: string | null;
  title: string;
}

export interface IApiResponseData {
  ok: number;
  msg: string;
  status: number;
  data: IPromotionData | INewsData | IVideoData | IBranchDetails | IProductData | IProductId;
}

export interface IProductId {
  id: number;
}

export interface IProductData {
  name: string;
  badge: string;
  price: number;
  short_description: string;
  product_model: string;
  content: string;
  tire_width: number;
  tire_height: number;
  tire_size: number;
  attr_brand: string;
  attr_model: string;
  attr_type: string;
  attr_road: string;
  attr_position: string;
  attr_range: string;
  attr_extra_a: string;
  attr_extra_b: string;
  attr_extra_c: string;
  perf_a: number;
  perf_b: number;
  perf_c: number;
  perf_d: number;
  perf_e: number;
  perf_f: number;
  block_content_a_image: string;
  block_content_a_title: string;
  block_content_a_info: string;
  block_content_b_image: string;
  block_content_b_title: string;
  block_content_b_info: string;
  block_content_c_image: string;
  block_content_c_title: string;
  block_content_c_info: string;
  block_content_d_image: string;
  block_content_d_title: string;
  block_content_d_info: string;
  block_content_e_image: string;
  block_content_e_title: string;
  block_content_e_info: string;
  block_content_f_image: string;
  block_content_f_title: string;
  block_content_f_info: string;
  block_content_g_image: string;
  block_content_g_title: string;
  block_content_g_info: string;
  block_content_h_image: string;
  block_content_h_title: string;
  block_content_h_info: string;
  image_a: string;
  image_b: string;
  image_c: string;
  image_d: string;
  image_e: any;
  attr_product_a: any;
  attr_product_b: string;
  attr_product_c: string;
  attr_product_d: any;
  attr_product_e: any;
  attr_product_f: any;
  attr_product_g: any;
  attr_product_h: any;
  attr_product_i: any;
  attr_product_j: any;
  brand_name: string;
  brand_image: string;
  load_index: number;
}

export interface IPromotionData {
  cover_image_url: string;
  header_share_image_url: string;
  title: string;
  excerpt: string;
  content_html: string;
  seo_page_title: string;
  seo_meta_description: string;
  seo_url: string;
  publish_time: string;
  unpublish_time: string;
}

export interface INewsData {
  cover_image_url: string;
  header_share_image_url: string;
  title: string;
  excerpt: string;
  content_html: string;
  seo_page_title: string;
  seo_meta_description: string;
  seo_url: string;
}
export interface IGalleryData {
  id: number;
  images_url: string;
  name: string;
  description: string;
  ip_address: string;
  hot_badge_enable: number;
  like_count: number;
  product_id: number;
  service_center_id: number;
  service_center_name: string;
  tire_model_name: string;
  tmn: string;
  like_status: number;
}

export interface IVideoData {
  cover_image_url: string | null;
  header_share_image_url: string | null;
  title: string;
  excerpt: string;
  youtube_embed: string;
  seo_page_title: string | null;
  seo_meta_description: string | null;
  seo_url: string | null;
}

export interface IBranchRow {
  id: number;
  name: string;
  code: string;
  tel: string;
  email: string;
  address: string;
  location_lat: string;
  location_lng: string;
  cover_image_url: string;
  distance?: number;
}

export interface IBranchDetails {
  name: string;
  code: string;
  tel: string;
  email: string;
  address: string;
  working_days: IWorkingDays;
  location_lat: string;
  location_lng: string;
  youtube_link: string | null;
  facebook_link: string | null;
  instagram_link: string | null;
  tiktok_link: string | null;
  cover_image_url: string;
}

interface IWorkingStatus {
  open: string;
  close: string;
  enable: number;
}

interface IWorkingDays {
  friday: IWorkingStatus;
  monday: IWorkingStatus;
  sunday: IWorkingStatus;
  tuesday: IWorkingStatus;
  saturday: IWorkingStatus;
  thursday: IWorkingStatus;
  wednesday: IWorkingStatus;
}

export interface IApiRequestContactBody {
  name: string;
  surname: string;
  email: string;
  tel: string;
  message: string;
}
export interface IApiRequestGalleryLikeBody {
  gallery_id: number;
  ip_address: string;
}

export interface IProductSearchOptions {
  width?: number | string;
  height?: number | string;
  size?: number | string;
  type?: string;
  brand?: string;
  model?: string;

  types?: string;
  highlights?: string;
}

export interface IBranchSearchOptions {
  q?: string;

  lat?: string; // 'xx.xxx' (latitudeY)
  lng?: string; // 'xx.xxx' (longitudeX)
}

export interface ITireDecIncRequire {
  width: number;
  height: number;
  size: number;
  loadindex: number;
}

export interface ISearchBlockOptions {
  size?: number | string;
  width?: number | string;
  height?: number | string;
  type?: string;
  brand?: string;
  model?: string;
}
export interface IMenuProduct {
  id: number | string;
  name: string;
  image: string;
}
export interface IFilters {
  value: string;
}

export interface IOption {
  paging?: IPaging;
  car_id?: number;
  car_model_id?: number;
  tire_brand_id?: number;
  tire_model_name?: string;
  sort_hot_badge?: string;
}

@Injectable({ providedIn: 'root' })
export abstract class ApiService {
  // SECTION: GET

  // SECTION: PRODUCTS
  //#region
  // NOTE: GET AllProduct
  abstract getAllProduct(): Observable<IAllData>;
  // NOTE: GET AllProductCategoryList
  abstract getAllProductCategory(
    visibility: string,
    category: string,
    options?: IProductSearchOptions,
    paging?: IPaging
  ): Observable<IAllData>;

  abstract getProductTable(visibility: string, category: string, options?: IProductSearchOptions): Observable<IAllData>;
  // NOTE: GET ProductById
  abstract getProductById(visibility: string, id: number): Observable<IProductData>;
  // NOTE: GET ProductTireDecInc
  abstract getTireDecInc(visibility: string, options: ETireDecInc, preq: ITireDecIncRequire): Observable<IProductId>;
  abstract getTireSelectedUpDown(size: string, brand: number, model: string): Observable<IProductId>;
  abstract getChangeTire(preq: ITireDecIncRequire, onChange: string): Observable<IProductId>;

  // NOTE: Get DataSearchBlock
  abstract getDataSearchBlock(
    category: string,
    input: ESearchBlockPath,
    visibility: string,
    options: ISearchBlockOptions
  ): Observable<any>;
  //#endregion
  // !SECTION //

  // SECTION: BANNERS
  //#region
  // NOTE: GET AllBanners
  abstract getAllBanner(visibility: string): Observable<IAllData>;
  //#endregion
  // !SECTION //

  // SECTION: POPUPS
  //#region
  // NOTE: GET AllPopup
  abstract getAllPopup(visibility: string): Observable<IAllData>;
  // !SECTION //

  // SECTION: PROMOTIONS
  //#region
  // NOTE: GET AllPromotion
  abstract getAllPromotion(visibility: string, paging?: IPaging): Observable<IAllData>;
  // NOTE: GET Promotion
  abstract getPromotionById(id: number): Observable<IPromotionData>;
  //#endregion
  // !SECTION //

  // SECTION: NEWS
  //#region
  // NOTE: GET AllNews
  abstract getAllNews(visibility: string, paging?: IPaging): Observable<IAllData>;
  // NOTE: GET NewsData
  abstract getNewsById(id: number): Observable<INewsData>;
  //#endregion
  // !SECTION //

  // NOTE: GET AllArticle
  abstract getAllArticle(visibility: string, paging?: IPaging): Observable<IAllData>;
  // NOTE: GET NewsData
  abstract getArticleById(id: number): Observable<INewsData>;
  //#endregion
  // !SECTION //

  // SECTION: VIDEO
  //#region
  // NOTE: GET AllVideo
  abstract getAllVideo(visibility: string, paging?: IPaging): Observable<IAllData>;
  // NOTE: GET VideoById
  abstract getVideoById(id: number): Observable<IVideoData>;
  //#endregion
  // !SECTION //

  // SECTION: CENTER_SERVICE
  //#region
  // NOTE: GET AllCenter
  abstract getAllCenter(): Observable<IApiResponseAll>;
  //#endregion
  // !SECTION //
  // !SECTION //

  // SECTION: BRANCH
  //#region
  // NOTE: GET AllBranch
  abstract getAllBranch(visibility: string, option: IBranchSearchOptions, paging?: IPaging): Observable<IAllData>;
  // NOTE: Get BranchById
  abstract getBranchById(visibility: string, id: number): Observable<IBranchDetails>;
  // NOTE: GET BranchByName
  abstract getBranchByName(visibility: string, option: IBranchSearchOptions, paging?: IPaging): Observable<IAllData>;
  // NOTE: GET BranchByCurrentLocation
  abstract getBranchByCurrentLocation(visibility: string, lat: number, lng: number): Observable<IAllData>;
  //#endregion
  // !SECTION //
  // !SECTION //

  //SECTION - GALLERY
  //#region
  // NOTE: GET AllGallery
  abstract getAllGallery(visibility: string, options?: IOption, sort_hot_badge?: number): Observable<IAllData>;
  // NOTE: GET GalleryById
  abstract getGalleryById(id: number, ip_address: string): Observable<IGalleryData>;
  ///NOTE - GET CarOptions
  abstract getGalleryCarOptions(): Observable<any>;
  ///NOTE - GET CarModelOptions
  abstract getGalleryCarModelOptions(brandId?: number): Observable<any>;
  ///NOTE - GET TireModelOptions
  abstract getGalleryTireModelOptions(visibility: string, id?: number): Observable<any>;
  ///NOTE - GET TireBrandOptions
  abstract getGalleryTireBrandOptions(): Observable<any>;
  //#endregion
  // !SECTION //
  ////////////////////////////////////////////

  // SECTION: POST

  // SECTION: CONTACT
  // NOTE: POST Contact (unknown return type)
  abstract postContact(body: IApiRequestContactBody): any;

  // NOTE: POST Gallery Like
  abstract postGalleryLike(
    galleryId: number,
    ipAddress: string
  ): Observable<{ success: boolean; like_count: number; like_status: number }>;
  // !SECTION //

  ///NOTE - POST GALLERY LIKE V2
  abstract postGalleryLikeV2(body: IApiRequestGalleryLikeBody): any;
  // !SECTION //
  abstract getMenuProduct(visibility: string): IMenuProduct | any;
  abstract getSubMenuTire(visibility: string, brandId?: string): any;
  abstract getSubMenuIDTire(visibility: string, name: string, brand?: any): any;
  abstract getSubMenuBrandTire(visibility: string): any;
  abstract getSubMenuModelTire(
    visibility: string,
    category: string,
    input: string,
    options: IProductSearchOptions
  ): any;

  abstract getHighlightsFilter(visibility: string): any;
  abstract getTypesFilter(visibility: string): any;
}
